module.exports = __webpack_public_path__ + "09_face.35d06842.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/09_face.png
// module id = 9ngt
// module chunks = 0